// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar-yeYU60_HYlHtFAeoZUsb","logo":"logo-jYKTy3ZWAvpUGWbHDeNH","menu":"menu-UeOi5b3sBBQZ7unSgmYX"};